import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Swal from "sweetalert2";
import franchiseAdminAPI from "../../../api/franchiseAdminAPI";
import BusinessCustomers from "./BusinessCustomers";
import PersonalCustomers from "./PersonalCustomers";

const CustomersTab = () => {
  const [activeTab, setActiveTab] = useState("personal");

  const [show, setShow] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [franchiseId, setFranchiseId] = useState(null); // 🔥 ADD THIS
  const referredBy = Cookies.get("userEmail");
  const isParent = Cookies.get("isParent") === "true";

  useEffect(() => {
    if (referredBy) {
      franchiseAdminAPI
        .getFranchiseDetailsByEmail(referredBy)
        .then((res) => {
          setReferralCode(res.data.referralCode);
          setFranchiseId(res.data.id);
        })
        .catch((err) => {
          console.error("Error fetching referral code:", err);
        });
    }
  }, [referredBy]);
  const handleClose = () => {
    setShow(false);
    setCustomerEmail("");
  };

  const handleShow = () => setShow(true);

  const handleSubmit = async () => {
    if (!customerEmail) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please enter email",
      });
      return;
    }

    const payload = {
      customerEmail,
      referredBy,
      referralCode,
    };

    try {
      setLoading(true);

      await franchiseAdminAPI.addCustomers(payload);

      setLoading(false);

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Invite sent successfully",
        confirmButtonColor: "#3085d6",
      });

      handleClose();
    } catch (error) {
      setLoading(false);

      console.error("Error sending invite:", error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Failed to send invite",
      });
    }
  };

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h1>
          <strong>Customers</strong>
        </h1>
        <Button variant="primary" onClick={handleShow}>
          Add Customer
        </Button>
      </div>

      {isParent ? (
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          id="franchiseCustomers-tabs"
        >
          <Tab eventKey="personal" title="Personal Customers">
            <PersonalCustomers referralCode={referralCode} />
          </Tab>

          <Tab eventKey="business" title="Franchise Customers">
            <BusinessCustomers franchiseId={franchiseId} />
          </Tab>
        </Tabs>
      ) : (
        // 🔥 NON-PARENT: show only personal directly
        <PersonalCustomers referralCode={referralCode} />
      )}

      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter customer email"
                value={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
              />
            </Form.Group>

            {/* Optional: show referral code */}
            <p className="mt-2 text-muted">Referral Code: {referralCode}</p>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                Sending...
              </>
            ) : (
              "Send"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CustomersTab;
